import { Component, OnInit } from '@angular/core';
import {ProductType, SpecificProductItem} from '../../models/CommonModels';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CommonService} from '../../shared/services/common.service';
import {SettingsService} from '../../shared/services/settings.service';
import {AlertService} from '../../shared/services/alert.service';
import * as Constants from "../../models/Constants";

@Component({
  selector: 'app-specific-product-config',
  templateUrl: './specific-product-config.component.html',
  styleUrls: ['./specific-product-config.component.css', '../module-config/module-config.component.css']
})
export class SpecificProductConfigComponent implements OnInit {
  public productTypes: ProductType[];
  public specificProductItems: SpecificProductItem[];
  public itemToBeDeleted: SpecificProductItem;
  public selectedProductTypeId: number;
  public selectedSpecificProductTypeId: number;
  public selectedSpecificProductTypeCode: string;
  modalRef: BsModalRef;

  constructor(private commonService: CommonService, private settingsService: SettingsService, private modalSerivce: BsModalService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.getProductTypes();
    (<any>jQuery('#metismenu')).metisMenu();

  }


  getProductTypes(): void {
    this.productTypes = [];
    this.commonService.getProductTypes().subscribe(productTypes => {
      if (productTypes && productTypes.length) {
        productTypes.forEach(productType => {
          if (productType.name.indexOf(Constants.PRODUCT_TYPE_COSMETICS) > -1 || productType.name === Constants.PRODUCT_TYPE_FOOD ||
            productType.name === Constants.PRODUCT_TYPE_SMALL_SCALE_MEDICINE ||
            productType.name === Constants.PRODUCT_TYPE_MEDICAL_GAS ||
            productType.name === Constants.PRODUCT_TYPE_MED_DEVICES ||
            productType.name === Constants.PRODUCT_TYPE_MEDICINE || 
            productType.name === Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES || 
            productType.name === Constants.PROUDCT_TYPE_BARRIER_FACE_MASK
             || productType.name === Constants.TOBACCO  ) {
            this.commonService.getSpecificProductsByproductType(productType.id).subscribe(specificProducts => {
              if (productType.name === Constants.PRODUCT_TYPE_MEDICINE || productType.name === Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES) {
                specificProducts = specificProducts.filter(sp => sp.title.indexOf('Import') === 0 ||
                sp.title.indexOf('Manufacture') === 0);
              }
              if (specificProducts && specificProducts.length) {
                if (this.productTypes.length === 0) {
                  this.selectedProductTypeId = productType.id;
                  this.selectedSpecificProductTypeId = specificProducts[0].id;
                  this.selectedSpecificProductTypeCode = specificProducts[0].specificProductCode;
                  this.fetchSpecificProductItems();
                }
                productType.specificProducts = specificProducts;
                this.productTypes.push(productType);
              }
            });
          }
        });
      }
    });
  }

  isActive(productTypeId, specificProductId) {
    return this.selectedProductTypeId === productTypeId && this.selectedSpecificProductTypeId === specificProductId;
  }

  addButtonClicked(specificProductItemTemplate) {
      this.modalRef = this.modalSerivce.show(specificProductItemTemplate, {backdrop: 'static', keyboard: false});
  }

  displayItemsForSelectedSpecificProduct(productType, specificProduct) {
    this.specificProductItems = [];
    this.selectedSpecificProductTypeId = specificProduct.id;
    this.selectedSpecificProductTypeCode = specificProduct.specificProductCode;
    this.selectedProductTypeId = productType.id;
    console.log('selectedSpecificProductTypeId: ' + specificProduct.id + ' selectedProductTypeId: ' + productType.id);

    this.fetchSpecificProductItems();
  }

  private fetchSpecificProductItems() {
    this.commonService.getSpecificProductItems(this.selectedSpecificProductTypeId).subscribe(
      res => {
        if (res) {
          this.specificProductItems = res;
        } else {
          this.alertService.error('Fetching items failed.');
        }
      },
      err => {
        this.alertService.error('Fetching items failed.');
      }
    );
  }

  addSpecificProductItem(name) {
    let specificProductItem = new SpecificProductItem();
    specificProductItem.name = name.value;
    specificProductItem.specificProductID = this.selectedSpecificProductTypeId;
    specificProductItem.spItemCode = this.selectedSpecificProductTypeCode;
    this.settingsService.addSpecificProductItem(specificProductItem).subscribe(
      res => {
        if (res) {
          this.alertService.success('Item Added successfully');
          this.fetchSpecificProductItems();
        }else {
          this.alertService.error('Adding item failed');
        }
      },
      error => {
        console.log('error creating item');
        this.alertService.error('Adding item failed');
      },
      () => {
        this.modalRef.hide();
      });
  }

  openDeleteAlertModal(alertModalTemplate, itemToBeDeleted) {
    this.modalRef = this.modalSerivce.show(alertModalTemplate, {backdrop: 'static', keyboard: false});
    this.itemToBeDeleted = itemToBeDeleted;
  }

  deleteItem() {
    this.settingsService.deleteSpecificProductItem(this.itemToBeDeleted.id).subscribe(
      res => {
        if (res) {
          this.alertService.success('Item deleted successfully');
          this.fetchSpecificProductItems();
        }else {
          this.alertService.error('Deleting item failed.');
        }
      },
      err => {
        this.alertService.error('Deleting item failed.');
      },
      () => {
        this.modalRef.hide();
      });
  }

}
